import { MutableRefObject, useEffect, useRef } from 'react';
import isMobile from '../utils/isMobile';

const useFocusByRefOnMount = <T extends HTMLElement>(): MutableRefObject<T> => {
  const ref = useRef<T>(null as unknown as T);
  useEffect(
    () => {
      if (!isMobile()) {
        ref?.current?.focus();
      }
    },
    [],
  );
  return ref;
};

export default useFocusByRefOnMount;
